import { useRef } from "react";
import { NavLink } from "react-router-dom";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import mainContentsArrowLeftIcon from "../../../assets/images/home/mainContentsArrowLeft.png";
import mainContentsArrowRightIcon from "../../../assets/images/home/mainContentsArrowRight.png";
import { homeNoticesLists } from "../../../data/home";
import { noticeLists } from "../../../data/notice";
import Icon from "../../Icon";
import * as S from "./styled";

const NoticeSlide = () => {
  const NoticeSlidePrevRef = useRef<HTMLButtonElement | null>(null);
  const NoticeSlideNextRef = useRef<HTMLButtonElement | null>(null);
  return (
    <S.NoticeSlideContainer
      data-aos="fade-up"
      data-aos-duration={1000}
      data-aos-easing="linear"
    >
      {noticeLists.length > 3 && (
        <S.NoticeSlidePrevButton ref={NoticeSlidePrevRef}>
          <Icon>
            <img src={mainContentsArrowLeftIcon} alt="logo" />
          </Icon>
        </S.NoticeSlidePrevButton>
      )}
      <Swiper
        modules={[Navigation]} // Navigation 모듈 추가
        spaceBetween={10}
        slidesPerView={2} // 기본값
        breakpoints={{
          900: { slidesPerView: 3, spaceBetween: 30 },
          500: { slidesPerView: 2, spaceBetween: 20 },
        }}
        navigation={{
          prevEl: NoticeSlidePrevRef.current,
          nextEl: NoticeSlideNextRef.current,
        }}
        onSwiper={(swiper: any) => {
          setTimeout(() => {
            if (swiper?.params?.navigation) {
              // Swiper가 초기화된 후 버튼을 다시 연결
              Object.assign(swiper.params.navigation, {
                prevEl: NoticeSlidePrevRef.current,
                nextEl: NoticeSlideNextRef.current,
              });
              swiper.navigation.init();
              swiper.navigation.update();
            }
          });
        }}
      >
        {noticeLists.map((homeNotice, index) => (
          <SwiperSlide key={homeNotice.title + index}>
            <NavLink to={`/notice/${homeNotice.id}`}>
              <S.HomeNoticeSlideWrapper>
                <S.HomeNoticeSlideImgWrap>
                  <img src={homeNotice.images[0]} alt={homeNotice.title} />
                </S.HomeNoticeSlideImgWrap>
                <S.HomeNoticeSlideTextWrapper>
                  <h6>{homeNotice.title}</h6>

                  <span>{homeNotice.date}</span>
                </S.HomeNoticeSlideTextWrapper>
              </S.HomeNoticeSlideWrapper>
            </NavLink>
          </SwiperSlide>
        ))}
      </Swiper>

      {noticeLists.length > 3 && (
        <S.NoticeSlideNextButton ref={NoticeSlideNextRef}>
          <Icon>
            <img src={mainContentsArrowRightIcon} alt="logo" />
          </Icon>
        </S.NoticeSlideNextButton>
      )}

      <S.ViewMoreButton>
        <NavLink to="/notice">더보기</NavLink>
      </S.ViewMoreButton>
    </S.NoticeSlideContainer>
  );
};

export default NoticeSlide;
